import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getEramanContentDrilldownData: { [key in ModuleConfig]: ModuleFields[] } = {
  eramanRegistration: [
    {
      fieldName: "Sign Up",
      fieldValue: "signUp",
      className: "col-span-6",
      type: "text",
      name: "signUp",
      formType: "input",
      label: "Sign Up for a Membership",
      placeholder: "Enter Sign Up Details",
      validation: { required: "Sign Up is required" },
    },
    {
      fieldName: "Sign Up Description",
      fieldValue: "signUpDescription",
      className: "col-span-6",
      type: "text",
      name: "signUpDescription",
      formType: "richText",
      label: "Sign Up Description",
      placeholder: "Enter Description",
      validation: { required: "Sign Up Description is required" },
    },
    {
      fieldName: "Username / Email",
      fieldValue: "username",
      className: "col-span-6",
      type: "text",
      name: "username",
      formType: "input",
      label: "Email / Username",
      placeholder: "Enter Email or Username",
      validation: { required: "Email / Username is required" },
    },
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Name as per I.C/Passport",
      fieldValue: "icAnndPassport",
      className: "col-span-6",
      type: "text",
      name: "icAnndPassport",
      formType: "input",
      label: "Name as per I.C/Passport",
      placeholder: "Enter Name",
      validation: { required: "Name as per I.C/Passport is required" },
    },
    {
      fieldName: "Nationality",
      fieldValue: "nationality",
      className: "col-span-6",
      type: "text",
      name: "nationality",
      formType: "input",
      label: "Nationality",
      placeholder: "Enter Nationality",
      validation: { required: "Nationality is required" },
    },
    {
     fieldName: "NRIC Number",
     fieldValue: "field_nric_data_field",
     className: "col-span-6",
     type: "text",
     name: "field_nric_data_field",
     formType: "input",
     label: "NRIC Number",
     placeholder: "Enter NRIC Number",
     validation: { required: "NRIC Number is required" },
    },
    {
      fieldName: "Passport Number",
      fieldValue: "passportNumber",
      className: "col-span-6",
      type: "text",
      name: "passportNumber",
      formType: "input",
      label: "Passport Number",
      placeholder: "Enter Passport Number",
      validation: { required: "Passport Number is required" },
    },
    {
      fieldName: "Mobile Number",
      fieldValue: "mobileNumber",
      className: "col-span-6",
      type: "text",
      name: "mobileNumber",
      formType: "input",
      label: "Mobile Number",
      placeholder: "Enter Mobile Number",
      validation: { required: "Mobile Number is required" },
    },
    {
      fieldName: "Email Address",
      fieldValue: "emailAddress",
      className: "col-span-6",
      type: "text",
      name: "emailAddress",
      formType: "input",
      label: "Email Address",
      placeholder: "Enter Email Address",
      validation: { required: "Email Address is required" },
    },
    {
      fieldName: "Agreement",
      fieldValue: "agree",
      className: "col-span-6",
      type: "text",
      name: "agree",
      formType: "input",
      label: "Agreement",
      placeholder: "Enter Agreement",
      validation: { required: "Agreement is required" },
    },
    {
      fieldName: "Agreement Email",
      fieldValue: "agreeEmail",
      className: "col-span-6",
      type: "text",
      name: "agreeEmail",
      formType: "input",
      label: "Agreement Email",
      placeholder: "Enter Agreement Email",
      validation: { required: "Agreement Email is required" },
    },
    // {
    //   fieldName: "Agreement SMS",
    //   fieldValue: "agreeSms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "agreeSms",
    //   formType: "input",
    //   label: "Agreement SMS",
    //   placeholder: "Enter Agreement SMS",
    //   validation: { required: "Agreement SMS is required" },
    // },
    {
      fieldName: "Password",
      fieldValue: "password",
      className: "col-span-6",
      type: "text",
      name: "password",
      formType: "input",
      label: "Password",
      placeholder: "Enter Password",
      validation: { required: "Password is required" },
    },
    {
      fieldName: "Confirm Password",
      fieldValue: "confirmPassword",
      className: "col-span-6",
      type: "text",
      name: "confirmPassword",
      formType: "input",
      label: "Confirm Password",
      placeholder: "Re-enter Password",
      validation: { required: "Confirm Password is required" },
    },
    {
      fieldName: "Password Conditions",
      fieldValue: "passwordCondition",
      className: "col-span-6",
      type: "text",
      name: "passwordCondition",
      formType: "richText",
      label: "Password Conditions",
      placeholder: "Enter Password Conditions",
      validation: { required: "Password Conditions is required" },
    },
    {
      fieldName: "Terms and Conditions",
      fieldValue: "termsAndConditions",
      className: "col-span-6",
      type: "text",
      name: "termsAndConditions",
      formType: "richText",
      label: "Terms and Conditions",
      placeholder: "Enter Terms and Conditions",
      validation: { required: "Terms and Conditions is required" },
    },
    {
      fieldName: "Asterisk Text",
      fieldValue: "asterisktext",
      className: "col-span-6",
      type: "text",
      name: "asterisktext",
      formType: "input",
      label: "Asterisk Text",
      placeholder: "Enter Asterisk Text",
      validation: { required: "Asterisk Text is required" },
    },
    {
      fieldName: "Register",
      fieldValue: "register",
      className: "col-span-6",
      type: "text",
      name: "register",
      formType: "input",
      label: "Register",
      placeholder: "Enter the Register",
      validation: { required: "Register is required" },
    },
    {
      fieldName: "Eraman User Text",
      fieldValue: "field_eraman_user_text",
      className: "col-span-6",
      type: "text",
      name: "field_eraman_user_text",
      formType: "input",
      label: "Eraman User Text",
      placeholder: "Enter Eraman User Text",
      validation: { required: "Eraman User Text is required" },
    },
    {
      fieldName: "Login Here Text",
      fieldValue: "field_login_text_for_register",
      className: "col-span-6",
      type: "text",
      name: "field_login_text_for_register",
      formType: "input",
      label: "Login Here Text",
      placeholder: "Enter Login Here Text",
      validation: { required: "Login Here Text is required" },
    },
    {
      fieldName: "Login Cover",
      fieldValue: "field_login_cover",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "field_login_cover",
      formType: "file",
      label: "Login Cover",
      placeholder: "Enter Login Cover",
      validation: { required: "Login Cover is Required" },
      imageDimension: {
        width: 740,
        height: 1042
      }
    },
  ],
  eramanIcons: [
    {
      fieldName: "White Heart",
      fieldValue: "field_whiteheart_image",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "field_whiteheart_image",
      formType: "file",
      label: "White Heart",
      placeholder: "Enter White Heart",
      validation: { required: "White Heart is Required" },
      imageDimension: {
        width: 20,
        height: 20
      }
    },
    {
      fieldName: "Red Heart",
      fieldValue: "field_redheart_image",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "field_redheart_image",
      formType: "file",
      label: "Red Heart",
      placeholder: "Enter Red Heart",
      validation: { required: "Red Heart is Required" },
      imageDimension: {
        width: 20,
        height: 20
      }
    },
    // {
    //   fieldName: "Awards Cover",
    //   fieldValue: "field_awardscover_image",
    //   className: "col-span-6",
    //   usedFileType: "image/*",
    //   type: "image",
    //   name: "field_awardscover_image",
    //   formType: "file",
    //   label: "Awards Cover",
    //   placeholder: "Enter Awards Cover",
    //   validation: { required: "Awards Cover is Required" },
    // },
    {
      fieldName: "E-Logo Image",
      fieldValue: "field_elogo_image",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "field_elogo_image",
      formType: "file",
      label: "E-Logo Image",
      placeholder: "Enter E-Logo Image",
      validation: { required: "E-Logo Image is Required" },
      imageDimension: {
        width: 50,
        height: 40
      }
    },
    {
      fieldName: "E-Card Image",
      fieldValue: "field_ecard_image",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "field_ecard_image",
      formType: "file",
      label: "E-Card Image",
      placeholder: "Enter E-Card Image",
      validation: { required: "E-Card Image is Required" },
      imageDimension: {
        width: 80,
        height: 47
      }
    },
    {
      fieldName: "Logo Image",
      fieldValue: "field_logo_new_image",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "field_logo_new_image",
      formType: "file",
      label: "Logo Image",
      placeholder: "Enter Logo Image",
      validation: { required: "Logo Image is Required" },
      imageDimension: {
        width: 210,
        height: 45
      }
    },
    {
      fieldName: "Wishlist Image",
      fieldValue: "field_empty_wishlist_image",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "field_empty_wishlist_image",
      formType: "file",
      label: "Wishlist Image",
      placeholder: "Enter Wishlist Image",
      validation: { required: "Wishlist Image is Required" },
      imageDimension: {
        width: 500,
        height: 500
      }
    },
    {
      fieldName: "Download Icon",
      fieldValue: "field_download_image",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "field_download_image",
      formType: "file",
      label: "Download Icon",
      placeholder: "Enter Download Icon",
      validation: { required: "Download Icon is Required" },
      imageDimension: {
        width: 30,
        height: 30
      }
    },
    {
      fieldName: "Star Rate",
      fieldValue: "field_star_rate_image",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "field_star_rate_image",
      formType: "file",
      label: "Star Rate",
      placeholder: "Enter Star Rate",
      validation: { required: "Star Rate is Required" },
      imageDimension: {
        width: 20,
        height: 20
      }
    },

  ],
  eramanForgotPassword: [
    // {
    //   fieldName: "Title",
    //   fieldValue: "title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "title",
    //   formType: "input",
    //   label: "Title",
    //   placeholder: "Enter Title",
    //   validation: { required: "Title is Required" },
    // },
    // },
    // {
    //   fieldName: "Continue with Google",
    //   fieldValue: "field_contine_with_google_text",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_contine_with_google_text",
    //   formType: "input",
    //   label: "Continue with Google Text",
    //   placeholder: "Enter Continue with Google",
    //   validation: { required: "Continue with Google is Required" },
    // },
    // {
    //   fieldName: "Continue with Facebook",
    //   fieldValue: "field_continue_with_facebook",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_continue_with_facebook",
    //   formType: "input",
    //   label: "Continue with Facebook",
    //   placeholder: "Enter Continue with Facebook",
    //   validation: { required: "Continue with Facebook is Required" },
    // },

    // {
    //   fieldName: "Eye Icon",
    //   fieldValue: "field_eye_icon",
    //   className: "col-span-6",
    //   usedFileType: "image/*",
    //   type: "image",
    //   name: "field_eye_icon",
    //   formType: "file",
    //   label: "Eye Icon",
    //   placeholder: "Enter Eye Icon",
    //   validation: { required: "Eye Icon is Required" },
    // },
    // {
    //   fieldName: "Facebook Icon",
    //   fieldValue: "field_icon_facebook",
    //   className: "col-span-6",
    //   usedFileType: "image/*",
    //   type: "image",
    //   name: "field_icon_facebook",
    //   formType: "file",
    //   label: "Facebook Icon",
    //   placeholder: "Enter Facebook Icon",
    //   validation: { required: "Facebook Icon is Required" },
    // },
    // {
    //   fieldName: "Icon Image",
    //   fieldValue: "field_icon_image",
    //   className: "col-span-6",
    //   type: "image",
    //   usedFileType: "image/*",
    //   name: "field_icon_image",
    //   formType: "file",
    //   label: "Icon Image",
    //   placeholder: "Enter Icon Image",
    //   validation: { required: "Icon Image is Required" },
    // },
    // {
    //   fieldName: "Password Text",
    //   fieldValue: "field_password_text",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_password_text",
    //   formType: "input",
    //   label: "Password Text",
    //   placeholder: "Enter Password Text",
    //   validation: { required: "Password Text is Required" },
    // },
    // {
    //   fieldName: "Forgot Password Text",
    //   fieldValue: "field_forgot_password_text",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_forgot_password_text",
    //   formType: "input",
    //   label: "Forgot Password Text",
    //   placeholder: "Enter Forgot Password Text",
    //   validation: { required: "Forgot Password Text is Required" },
    // },
    {
      fieldName: "Forgot Password Text",
      fieldValue: "field_sign_uptext",
      className: "col-span-6",
      type: "text",
      name: "field_sign_uptext",
      formType: "input",
      label: "Forgot Password Text",
      placeholder: "Enter Forgot Password Text",
      validation: { required: "Forgot Password Text is Required" },
    },
    {
      fieldName: "Forgot Password Description",
      fieldValue: "field_sign_up_description",
      className: "col-span-6",
      type: "text",
      name: "field_sign_up_description",
      formType: "richText",
      label: "Forgot Password Description",
      placeholder: "Enter Description",
      validation: { required: "Forgot Password Description is Required" },
    },
    {
      fieldName: "Email Address",
      fieldValue: "field_email_username_text",
      className: "col-span-6",
      type: "text",
      name: "field_email_username_text",
      formType: "input",
      label: "Email Address",
      placeholder: "Enter Email Address",
      validation: { required: "Email Address is required" },
    },
    {
      fieldName: "Submit Button Text",
      fieldValue: "field_register_text",
      className: "col-span-6",
      type: "text",
      name: "field_register_text",
      formType: "input",
      label: "Submit Button Text",
      placeholder: "Enter Submit Button Text",
      validation: { required: "Submit Button Text is required" },
    },
    {
      fieldName: "Remember Password Text",
      fieldValue: "field_eraman_user_text",
      className: "col-span-6",
      type: "text",
      name: "field_eraman_user_text",
      formType: "input",
      label: "Remember Password Text",
      placeholder: "Enter Remember Password Text",
      validation: { required: "Remember Password Text is Required" },
    },
    {
      fieldName: "Login Text for Register",
      fieldValue: "field_login_text_for_register",
      className: "col-span-6",
      type: "text",
      name: "field_login_text_for_register",
      formType: "input",
      label: "Login Text for Register Text",
      placeholder: "Enter Login Text for Register Text",
      validation: { required: "Login Text for Register Text is required" },
    },


  ],
  eramanSignIn: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is Required" },
    },
    {
      fieldName: "Register Text",
      fieldValue: "field_register_text",
      className: "col-span-6",
      type: "text",
      name: "field_register_text",
      formType: "input",
      label: "Register Text Text",
      placeholder: "Enter Register Text",
      validation: { required: "Register Text is required" },
    },
    {
      fieldName: "Continue with Google",
      fieldValue: "field_contine_with_google_text",
      className: "col-span-6",
      type: "text",
      name: "field_contine_with_google_text",
      formType: "input",
      label: "Continue with Google Text",
      placeholder: "Enter Continue with Google",
      validation: { required: "Continue with Google is Required" },
    },
    {
      fieldName: "Continue with Facebook",
      fieldValue: "field_continue_with_facebook",
      className: "col-span-6",
      type: "text",
      name: "field_continue_with_facebook",
      formType: "input",
      label: "Continue with Facebook",
      placeholder: "Enter Continue with Facebook",
      validation: { required: "Continue with Facebook is Required" },
    },
    {
      fieldName: "Login Text for Register",
      fieldValue: "field_login_text_for_register",
      className: "col-span-6",
      type: "text",
      name: "field_login_text_for_register",
      formType: "input",
      label: "Login Text for Register Text",
      placeholder: "Enter Login Text for Register Text",
      validation: { required: "Login Text for Register Text is required" },
    },
    {
      fieldName: "Email Address",
      fieldValue: "field_email_username_text",
      className: "col-span-6",
      type: "text",
      name: "field_email_username_text",
      formType: "input",
      label: "Email Address Label",
      placeholder: "Enter Email Address Label",
      validation: { required: "Email Address Label is required" },
    },
    {
      fieldName: "Eraman User Text",
      fieldValue: "field_eraman_user_text",
      className: "col-span-6",
      type: "text",
      name: "field_eraman_user_text",
      formType: "input",
      label: "Eraman User Text Text",
      placeholder: "Enter Eraman User Text",
      validation: { required: "Eraman User Text is Required" },
    },
    // {
    //   fieldName: "Eye Icon",
    //   fieldValue: "field_eye_icon",
    //   className: "col-span-6",
    //   usedFileType: "image/*",
    //   type: "image",
    //   name: "field_eye_icon",
    //   formType: "file",
    //   label: "Eye Icon",
    //   placeholder: "Enter Eye Icon",
    //   validation: { required: "Eye Icon is Required" },
    // },
    {
      fieldName: "Facebook Icon",
      fieldValue: "field_icon_facebook",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "field_icon_facebook",
      formType: "file",
      label: "Facebook Icon",
      placeholder: "Enter Facebook Icon",
      validation: { required: "Facebook Icon is Required" },
      imageDimension: {
        width: 33,
        height: 33
      }
    },
    {
      fieldName: "Google Icon",
      fieldValue: "field_icon_image",
      className: "col-span-6",
      type: "image",
      usedFileType: "image/*",
      name: "field_icon_image",
      formType: "file",
      label: "Google Icon",
      placeholder: "Enter Google Icon",
      validation: { required: "Google Icon is Required" },
      imageDimension: {
        width: 33,
        height: 33
      }
    },
    {
      fieldName: "Password Text",
      fieldValue: "field_password_text",
      className: "col-span-6",
      type: "text",
      name: "field_password_text",
      formType: "input",
      label: "Password Text",
      placeholder: "Enter Password Text",
      validation: { required: "Password Text is Required" },
    },
    {
      fieldName: "Forgot Password Text",
      fieldValue: "field_forgot_password_text",
      className: "col-span-6",
      type: "text",
      name: "field_forgot_password_text",
      formType: "input",
      label: "Forgot Password Text",
      placeholder: "Enter Forgot Password Text",
      validation: { required: "Forgot Password Text is Required" },
    },
    {
      fieldName: "Sign In Description",
      fieldValue: "field_sign_up_description",
      className: "col-span-6",
      type: "text",
      name: "field_sign_up_description",
      formType: "richText",
      label: "Sign In Description",
      placeholder: "Enter Description",
      validation: { required: "Sign In Description is Required" },
    },
    {
      fieldName: "Sign In Text",
      fieldValue: "field_sign_uptext",
      className: "col-span-6",
      type: "text",
      name: "field_sign_uptext",
      formType: "input",
      label: "Sign In Text",
      placeholder: "Enter Sign In Text",
      validation: { required: "Sign In Text is Required" },
    },
  ],
  eramanOTP: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Verification Code Header",
      fieldValue: "field_sign_uptext",
      className: "col-span-6",
      type: "text",
      name: "field_sign_uptext",
      formType: "input",
      label: "Verification Code Header",
      placeholder: "Enter Verification Code Header",
      validation: { required: "Verification Code Header is required" },
    },
    {
      fieldName: "OTP Description",
      fieldValue: "field_sign_up_description",
      className: "col-span-6",
      type: "text",
      name: "field_sign_up_description",
      formType: "richText",
      label: "OTP Description",
      placeholder: "Enter Description",
      validation: { required: "OTP Description is required" },
    },
    {
      fieldName: "OTP Receive Text",
      fieldValue: "field_otp_request_text",
      className: "col-span-6",
      type: "text",
      name: "field_otp_request_text",
      formType: "input",
      label: "OTP Receive Text",
      placeholder: "Enter OTP Receive Text",
      validation: { required: "OTP Receive Text is required" },
    },
    {
      fieldName: "OTP Request Text",
      fieldValue: "field_repeat_again",
      className: "col-span-6",
      type: "text",
      name: "field_repeat_again",
      formType: "input",
      label: "OTP Request Text",
      placeholder: "Enter OTP Request Text",
      validation: { required: "OTP Request Text is required" },
    },
    {
      fieldName: "Verify OTP Button",
      fieldValue: "field_upgrade_text",
      className: "col-span-6",
      type: "text",
      name: "field_upgrade_text",
      formType: "input",
      label: "Verify OTP Button Text",
      placeholder: "Enter Verify OTP Button Text",
      validation: { required: "Verify OTP Button Text is required" },
    },
  ],
  eramanUserProfile: [
    {
      fieldName: "Name (EN)",
      fieldValue: "field_name_text",
      className: "col-span-6",
      type: "text",
      name: "field_name_text",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name Label in English",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_name_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_name_text_ms",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name Label in Malay",
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_name_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_name_text_zh",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name Label in Chinese",
    },
    {
      fieldName: "Username (EN)",
      fieldValue: "field_username_text",
      className: "col-span-6",
      type: "text",
      name: "field_username_text",
      formType: "input",
      label: "Username (EN)",
      placeholder: "Enter Username Label in English",
      validation: { required: "Username (EN) is required" },
    },
    {
      fieldName: "Username (MS)",
      fieldValue: "field_user_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_user_name_ms",
      formType: "input",
      label: "Username (MS)",
      placeholder: "Enter Username Label in Malay",
    },
    {
      fieldName: "Username (ZH)",
      fieldValue: "field_user_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_user_name_zh",
      formType: "input",
      label: "Username (ZH)",
      placeholder: "Enter Username Label in Chinese",
    },
    {
      fieldName: "New Password (EN)",
      fieldValue: "field_new_password_text",
      className: "col-span-6",
      type: "text",
      name: "field_new_password_text",
      formType: "input",
      label: "New Password (EN)",
      placeholder: "Enter New Password Label in English",
      validation: { required: "New Password (EN) is required" },
    },
    {
      fieldName: "New Password (MS)",
      fieldValue: "field_new_password_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_new_password_text_ms",
      formType: "input",
      label: "New Password (MS)",
      placeholder: "Enter New Password Label in Malay",
    },
    {
      fieldName: "New Password (ZH)",
      fieldValue: "field_new_password_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_new_password_text_zh",
      formType: "input",
      label: "New Password (ZH)",
      placeholder: "Enter New Password Label in Chinese",
    },
    {
      fieldName: "Confirm Password (EN)",
      fieldValue: "field_confirm_password",
      className: "col-span-6",
      type: "text",
      name: "field_confirm_password",
      formType: "input",
      label: "Confirm Password (EN)",
      placeholder: "Enter Confirm Password Label in English",
      validation: { required: "Confirm Password (EN) is required" },
    },
    {
      fieldName: "Confirm Password (MS)",
      fieldValue: "field_confirm_password_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_confirm_password_text_ms",
      formType: "input",
      label: "Confirm Password (MS)",
      placeholder: "Enter Confirm Password Label in Malay",
    },
    {
      fieldName: "Confirm Password (ZH)",
      fieldValue: "field_confirm_password_zh",
      className: "col-span-6",
      type: "text",
      name: "field_confirm_password_zh",
      formType: "input",
      label: "Confirm Password (ZH)",
      placeholder: "Enter Confirm Password Label in Chinese",
    },
    {
      fieldName: "Password Conditions (EN)",
      fieldValue: "field_password_conditions",
      className: "col-span-6",
      type: "text",
      name: "field_password_conditions",
      formType: "richText",
      label: "Password Conditions (EN)",
      placeholder: "Enter Password Conditions in English",
      validation: { required: "Password Conditions (EN) is required" },
    },
    {
      fieldName: "Password Conditions (MS)",
      fieldValue: "field_password_conditions_ms",
      className: "col-span-6",
      type: "text",
      name: "field_password_conditions_ms",
      formType: "richText",
      label: "Password Conditions (MS)",
      placeholder: "Enter Password Conditions in Malay",
    },
    {
      fieldName: "Password Conditions (ZH)",
      fieldValue: "field_password_conditions_zh",
      className: "col-span-6",
      type: "text",
      name: "field_password_conditions_zh",
      formType: "richText",
      label: "Password Conditions (ZH)",
      placeholder: "Enter Password Conditions in Chinese",
    },
    {
      fieldName: "Email (EN)",
      fieldValue: "field_email_text",
      className: "col-span-6",
      type: "text",
      name: "field_email_text",
      formType: "input",
      label: "Email (EN)",
      placeholder: "Enter Email Label in English",
      validation: { required: "Email (EN) is required" },
    },
    {
      fieldName: "Email (MS)",
      fieldValue: "field_email_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_email_text_ms",
      formType: "input",
      label: "Email (MS)",
      placeholder: "Enter Email Label in Malay",
    },
    {
      fieldName: "Email (ZH)",
      fieldValue: "field_email_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_email_text_zh",
      formType: "input",
      label: "Email (ZH)",
      placeholder: "Enter Email Label in Chinese",
    },
    {
      fieldName: "EPC ID (EN)",
      fieldValue: "field_epc_id_text",
      className: "col-span-6",
      type: "text",
      name: "field_epc_id_text",
      formType: "input",
      label: "EPC ID (EN)",
      placeholder: "Enter EPC ID Label in English",
      validation: { required: "EPC ID (EN) is required" },
    },
    {
      fieldName: "EPC ID (MS)",
      fieldValue: "field_epc_id_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_epc_id_text_ms",
      formType: "input",
      label: "EPC ID (MS)",
      placeholder: "Enter EPC ID Label in Malay",
    },
    {
      fieldName: "EPC ID (ZH)",
      fieldValue: "field_epc_id_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_epc_id_text_zh",
      formType: "input",
      label: "EPC ID (ZH)",
      placeholder: "Enter EPC ID Label in Chinese",
    },
    {
      fieldName: "Update Button (EN)",
      fieldValue: "field_update_text",
      className: "col-span-6",
      type: "text",
      name: "field_update_text",
      formType: "input",
      label: "Update Button (EN)",
      placeholder: "Enter Update Button Text in English",
      validation: { required: "Update Button (EN) is required" },
    },
    {
      fieldName: "Update Button (MS)",
      fieldValue: "field_update_ms",
      className: "col-span-6",
      type: "text",
      name: "field_update_ms",
      formType: "input",
      label: "Update Button (MS)",
      placeholder: "Enter Update Button Text in Malay",
    },
    {
      fieldName: "Update Button (ZH)",
      fieldValue: "field_update_zh",
      className: "col-span-6",
      type: "text",
      name: "field_update_zh",
      formType: "input",
      label: "Update Button (ZH)",
      placeholder: "Enter Update Button Text in Chinese",
    },
  ],
  epcMembership: [
    {
      fieldName: "Membership Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Membership Title (EN)",
      placeholder: "Enter Title in English",
      validation: { required: "Membership Title (EN) is required" },
    },
        {
      fieldName: "EPC Description (EN)",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Membership Description (EN)",
      placeholder: "Enter Membership Description in English",
      validation: { required: "Membership Description (EN) is required" },
    },
    {
      fieldName: "EPC Description (MS)",
      fieldValue: "field_epc_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_epc_description_ms",
      formType: "richText",
      label: "EPC Description (MS)",
      placeholder: "Enter EPC Description in Malay",
    },
    {
      fieldName: "EPC Description (ZH)",
      fieldValue: "field_epc_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_epc_description_zh",
      formType: "richText",
      label: "EPC Description (ZH)",
      placeholder: "Enter EPC Description in Chinese",
    },

    {
      fieldName: "EPC Member Description (EN)",
      fieldValue: "field_epc_member_description",
      className: "col-span-6",
      type: "text",
      name: "field_epc_member_description",
      formType: "richText",
      label: "EPC Member Description (EN)",
      placeholder: "Enter EPC Member Description (EN)",
      validation: { required: "EPC Member Description (EN) is required" },
    },
    {
      fieldName: "EPC Member Description (MS)",
      fieldValue: "field_epc_member_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_epc_member_description_ms",
      formType: "richText",
      label: "EPC Member Description (MS)",
      placeholder: "Enter EPC Member Description in Malay",
    },
    {
      fieldName: "EPC Member Description (ZH)",
      fieldValue: "field_epc_member_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_epc_member_description_zh",
      formType: "richText",
      label: "EPC Member Description (ZH)",
      placeholder: "Enter EPC Member Description in Chinese",
    },
    {
      fieldName: "EPC ID (EN)",
      fieldValue: "field_epc_id",
      className: "col-span-6",
      type: "text",
      name: "field_epc_id",
      formType: "input",
      label: "EPC ID (EN)",
      placeholder: "Enter EPC ID Label in English",
      validation: { required: "EPC ID (EN) is required" },
    },
    {
      fieldName: "EPC ID (MS)",
      fieldValue: "field_epc_id_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_epc_id_text_ms",
      formType: "input",
      label: "EPC ID (MS)",
      placeholder: "Enter EPC ID Label in Malay",
    },
    {
      fieldName: "EPC ID (ZH)",
      fieldValue: "field_epc_id_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_epc_id_text_zh",
      formType: "input",
      label: "EPC ID (ZH)",
      placeholder: "Enter EPC ID Label in Chinese",
    },
    {
      fieldName: "Full Name (EN)",
      fieldValue: "field_full_name",
      className: "col-span-6",
      type: "text",
      name: "field_full_name",
      formType: "input",
      label: "Full Name (EN)",
      placeholder: "Enter Full Name Label in English",
      validation: { required: "Full Name (EN) is required" },
    },
    {
      fieldName: "Full Name (MS)",
      fieldValue: "field_full_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_full_name_ms",
      formType: "input",
      label: "Full Name (MS)",
      placeholder: "Enter Full Name Label in Malay",
    },
    {
      fieldName: "Full Name (ZH)",
      fieldValue: "field_full_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_full_name_zh",
      formType: "input",
      label: "Full Name (ZH)",
      placeholder: "Enter Full Name Label in Chinese",
    },
    {
      fieldName: "EPC Card (EN)",
      fieldValue: "field_epc_card_heading_en",
      className: "col-span-6",
      type: "text",
      name: "field_epc_card_heading_en",
      formType: "input",
      label: "EPC Card (EN)",
      placeholder: "Enter EPC Card (EN)",
      validation: { required: "EPC Card (EN) is required" },
    },
    {
      fieldName: "EPC Card (MS)",
      fieldValue: "field_epc_card_heading_ms",
      className: "col-span-6",
      type: "text",
      name: "field_epc_card_heading_ms",
      formType: "input",
      label: "EPC Card (MS)",
      placeholder: "Enter EPC Card (MS)",
    },
    {
      fieldName: "EPC Card (ZH)",
      fieldValue: "field_epc_card_heading_zh",
      className: "col-span-6",
      type: "text",
      name: "field_epc_card_heading_zh",
      formType: "input",
      label: "EPC Card (ZH)",
      placeholder: "Enter EPC Card (ZH)",
    },
    {
      fieldName: "Classic Card",
      fieldValue: "classicCard",
      className: "col-span-6",
      type: "image",
      usedFileType: "image/*",
      name: "classicCard",
      formType: "file",
      label: "Classic Card",
      placeholder: "Enter Classic Card URL",
      validation: { required: "Classic Card is required" },
      imageDimension: {
        width: 600,
        height: 380
      }
    },
    {
      fieldName: "Preferred Card",
      fieldValue: "preferredCard",
      className: "col-span-6",
      type: "image",
      usedFileType: "image/*",
      name: "preferredCard",
      formType: "file",
      label: "Preferred Card",
      placeholder: "Enter Preferred Card URL",
      validation: { required: "Preferred Card is required" },
      imageDimension: {
        width: 600,
        height: 380
      }
    },
    {
      fieldName: "Priority Card",
      fieldValue: "priorityCard",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "priorityCard",
      formType: "file",
      label: "Priority Card",
      placeholder: "Enter Priority Card URL",
      validation: { required: "Priority Card is required" },
      imageDimension: {
        width: 600,
        height: 380
      }
    },
    {
      fieldName: "NRIC (EN)",
      fieldValue: "field_nric_text",
      className: "col-span-6",
      type: "text",
      name: "field_nric_text",
      formType: "input",
      label: "NRIC (EN)",
      placeholder: "Enter NRIC Label (EN)",
      validation: { required: "NRIC (EN) is required" },
    },
    {
      fieldName: "NRIC (MS)",
      fieldValue: "field_nric_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_nric_text_ms",
      formType: "input",
      label: "NRIC (MS)",
      placeholder: "Enter NRIC Label in Malay",
    },
    {
      fieldName: "NRIC (ZH)",
      fieldValue: "field_nric_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_nric_text_zh",
      formType: "input",
      label: "NRIC (ZH)",
      placeholder: "Enter NRIC Label in Chinese",
    },
    {
      fieldName: "Passport (EN)",
      fieldValue: "field_passport_text",
      className: "col-span-6",
      type: "text",
      name: "field_passport_text",
      formType: "input",
      label: "Passport (EN)",
      placeholder: "Enter Passport (EN)",
      validation: { required: "Passport (EN) is required" },
    },
    {
      fieldName: "Passport (MS)",
      fieldValue: "field_password_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_password_text_ms",
      formType: "input",
      label: "Passport (MS)",
      placeholder: "Enter Passport Label in Malay",
    },
    {
      fieldName: "Passport (ZH)",
      fieldValue: "field_passport_number_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_passport_number_text_zh",
      formType: "input",
      label: "Passport (ZH)",
      placeholder: "Enter Passport Label in Chinese",
    },
    {
      fieldName: "Date of Birth (EN)",
      fieldValue: "field_date_of_birth_text",
      className: "col-span-6",
      type: "text",
      name: "field_date_of_birth_text",
      formType: "input",
      label: "Date of Birth (EN)",
      placeholder: "Enter Date of Birth Label in English",
      validation: { required: "Date of Birth (EN) is required" },
    },
    {
      fieldName: "Date of Birth (MS)",
      fieldValue: "field_date_of_birth_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_date_of_birth_text_ms",
      formType: "input",
      label: "Date of Birth (MS)",
      placeholder: "Enter Date of Birth Label in Malay",
    },
    {
      fieldName: "Date of Birth (ZH)",
      fieldValue: "field_date_of_birth_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_date_of_birth_text_zh",
      formType: "input",
      label: "Date of Birth (ZH)",
      placeholder: "Enter Date of Birth Label in Chinese",
    },
    {
      fieldName: "EPC Type (EN)",
      fieldValue: "field_epc_type",
      className: "col-span-6",
      type: "text",
      name: "field_epc_type",
      formType: "input",
      label: "EPC Type (EN)",
      placeholder: "Enter EPC Type (EN)",
      validation: { required: "EPC Type (EN) is required" },
    },
    {
      fieldName: "EPC Type (MS)",
      fieldValue: "field_epc_type_ms",
      className: "col-span-6",
      type: "text",
      name: "field_epc_type_ms",
      formType: "input",
      label: "EPC Type (MS)",
      placeholder: "Enter EPC Type Label in Malay",
    },
    {
      fieldName: "EPC Type (ZH)",
      fieldValue: "field_epc_type_zh",
      className: "col-span-6",
      type: "text",
      name: "field_epc_type_zh",
      formType: "input",
      label: "EPC Type (ZH)",
      placeholder: "Enter EPC Type Label in Chinese",
    },
       {
      fieldName: "State (EN)",
      fieldValue: "field_state_text",
      className: "col-span-6",
      type: "text",
      name: "field_state_text",
      formType: "input",
      label: "State (EN)",
      placeholder: "Enter State Label in English",
      validation: { required: "State (EN) is required" },
    },
    {
      fieldName: "State (MS)",
      fieldValue: "field_state_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_state_text_ms",
      formType: "input",
      label: "State (MS)",
      placeholder: "Enter State Label in Malay",
    },
    {
      fieldName: "State (ZH)",
      fieldValue: "field_state_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_state_text_zh",
      formType: "input",
      label: "State (ZH)",
      placeholder: "Enter State Label in Chinese",
    },

    {
      fieldName: "Expiry Date (EN)",
      fieldValue: "field_expiry_date_text",
      className: "col-span-6",
      type: "text",
      name: "field_expiry_date_text",
      formType: "input",
      label: "Expiry Date (EN)",
      placeholder: "Enter Expiry Date Label in English",
      validation: { required: "Expiry Date (EN) is required" },
    },
    {
      fieldName: "Expiry Date (MS)",
      fieldValue: "field_expiry_date_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_expiry_date_text_ms",
      formType: "input",
      label: "Expiry Date (MS)",
      placeholder: "Enter Expiry Date Label in Malay",
    },
    {
      fieldName: "Expiry Date (ZH)",
      fieldValue: "field_expiry_date_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_expiry_date_text_zh",
      formType: "input",
      label: "Expiry Date (ZH)",
      placeholder: "Enter Expiry Date Label in Chinese",
    },
    {
      fieldName: "Country (EN)",
      fieldValue: "field_country_text",
      className: "col-span-6",
      type: "text",
      name: "field_country_text",
      formType: "input",
      label: "Country (EN)",
      placeholder: "Enter Country Label in English",
      validation: { required: "Country (EN) is required" },
    },
    {
      fieldName: "Country (MS)",
      fieldValue: "field_country_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_country_text_ms",
      formType: "input",
      label: "Country (MS)",
      placeholder: "Enter Country Label in Malay",
    },
    {
      fieldName: "Country (ZH)",
      fieldValue: "field_country_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_country_text_zh",
      formType: "input",
      label: "Country (ZH)",
      placeholder: "Enter Country Label in Chinese",
    },
    {
      fieldName: "Gender (EN)",
      fieldValue: "field_gender_text",
      className: "col-span-6",
      type: "text",
      name: "field_gender_text",
      formType: "input",
      label: "Gender (EN)",
      placeholder: "Enter Gender Label in English",
      validation: { required: "Gender (EN) is required" },
    },
    {
      fieldName: "Gender (MS)",
      fieldValue: "field_gender_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_gender_text_ms",
      formType: "input",
      label: "Gender (MS)",
      placeholder: "Enter Gender Label in Malay",
    },
    {
      fieldName: "Gender (ZH)",
      fieldValue: "field_gender_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_gender_text_zh",
      formType: "input",
      label: "Gender (ZH)",
      placeholder: "Enter Gender Label in Chinese",
    },
    {
      fieldName: "Mobile Number (EN)",
      fieldValue: "field_mobile_number",
      className: "col-span-6",
      type: "text",
      name: "field_mobile_number",
      formType: "input",
      label: "Mobile Number (EN)",
      placeholder: "Enter Mobile Number Label in English",
      validation: { required: "Mobile Number (EN) is required" },
    },
    {
      fieldName: "Mobile Number (MS)",
      fieldValue: "field_mobile_number_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_mobile_number_text_ms",
      formType: "input",
      label: "Mobile Number (MS)",
      placeholder: "Enter Mobile Number Label in Malay",
    },
    {
      fieldName: "Mobile Number (ZH)",
      fieldValue: "field_mobile_number_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_mobile_number_text_zh",
      formType: "input",
      label: "Mobile Number (ZH)",
      placeholder: "Enter Mobile Number Label in Chinese",
    },
    {
      fieldName: "Nationality (EN)",
      fieldValue: "field_nationality",
      className: "col-span-6",
      type: "text",
      name: "field_nationality",
      formType: "input",
      label: "Nationality (EN)",
      placeholder: "Enter Nationality Label in English",
      validation: { required: "Nationality (EN) is required" },
    },
    {
      fieldName: "Nationality (MS)",
      fieldValue: "field_nationality_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_nationality_text_ms",
      formType: "input",
      label: "Nationality (MS)",
      placeholder: "Enter Nationality Label in Malay",
    },
    {
      fieldName: "Nationality (ZH)",
      fieldValue: "field_nationality_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_nationality_text_zh",
      formType: "input",
      label: "Nationality (ZH)",
      placeholder: "Enter Nationality Label in Chinese",
    },
      {
      fieldName: "Email (EN)",
      fieldValue: "field_email",
      className: "col-span-6",
      type: "text",
      name: "field_email",
      formType: "input",
      label: "Email (EN)",
      placeholder: "Enter Email (EN)",
      validation: { required: "Email (EN) is required" },
    },
    {
      fieldName: "Email (MS)",
      fieldValue: "field_email_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_email_text_ms",
      formType: "input",
      label: "Email (MS)",
      placeholder: "Enter Email Label in Malay",
    },
    {
      fieldName: "Email (ZH)",
      fieldValue: "field_email_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_email_text_zh",
      formType: "input",
      label: "Email (ZH)",
      placeholder: "Enter Email Label in Chinese",
    },
        {
      fieldName: "Promotion Material (EN)",
      fieldValue: "field_promotion_material",
      className: "col-span-6",
      type: "text",
      name: "field_promotion_material",
      formType: "input",
      label: "Promotion Material (EN)",
      placeholder: "Enter Promotion Material Label in English",
      validation: { required: "Promotion Material (EN) is required" },
    },
    {
      fieldName: "Promotion Material (MS)",
      fieldValue: "field_promotion_material_ms",
      className: "col-span-6",
      type: "text",
      name: "field_promotion_material_ms",
      formType: "input",
      label: "Promotion Material (MS)",
      placeholder: "Enter Promotion Material Label in Malay",
    },
    {
      fieldName: "Promotion Material (ZH)",
      fieldValue: "field_promotion_material_zh",
      className: "col-span-6",
      type: "text",
      name: "field_promotion_material_zh",
      formType: "input",
      label: "Promotion Material (ZH)",
      placeholder: "Enter Promotion Material Label in Chinese",
    },
    {
      fieldName: "Title Text (EN)",
      fieldValue: "title_text_En",
      className: "col-span-6",
      type: "text",
      name: "title_text_En",
      formType: "input",
      label: "Title Text (EN)",
      placeholder: "Enter Title Text in English",
      validation: { required: "Title Text (EN) is required" },
    },
    {
      fieldName: "Title Text (MS)",
      fieldValue: "field_title_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_title_text_ms",
      formType: "input",
      label: "Title Text (MS)",
      placeholder: "Enter Title Text in Malay",
    },
    {
      fieldName: "Title Text (ZH)",
      fieldValue: "field_title_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_title_text_zh",
      formType: "input",
      label: "Title Text (ZH)",
      placeholder: "Enter Title Text in Chinese",
    },
 
    {
      fieldName: "Edit EPC Details Button(EN)",
      fieldValue: "field_edit_epc_details_text",
      className: "col-span-6",
      type: "text",
      name: "field_edit_epc_details_text",
      formType: "input",
      label: "Edit EPC Details (EN)",
      placeholder: "Enter Edit EPC Details Button(EN)",
      validation: { required: "Edit EPC Details (EN) is required" },
    },
    {
      fieldName: "Edit EPC Details Button(MS)",
      fieldValue: "field_edit_epc_details_ms",
      className: "col-span-6",
      type: "text",
      name: "field_edit_epc_details_ms",
      formType: "input",
      label: "Edit EPC Details Button(MS)",
      placeholder: "Enter Edit EPC Details Button(MS)",
    },
    {
      fieldName: "Edit EPC Details Button(ZH)",
      fieldValue: "field_edit_epc_details_zh",
      className: "col-span-6",
      type: "text",
      name: "field_edit_epc_details_zh",
      formType: "input",
      label: "Edit EPC Details Button(ZH)",
      placeholder: "EEnter Edit EPC Details Button(ZH)",
    },
    {
      fieldName: "Upgrade Button (EN)",
      fieldValue: "field_upgrade_text",
      className: "col-span-6",
      type: "text",
      name: "field_upgrade_text",
      formType: "input",
      label: "Upgrade Button (EN)",
      placeholder: "Enter Upgrade Button Text in English",
      validation: { required: "Upgrade Button (EN) is required" },
    },
    {
      fieldName: "Upgrade Button (MS)",
      fieldValue: "field_upgrade_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_upgrade_text_ms",
      formType: "input",
      label: "Upgrade Button (MS)",
      placeholder: "Enter Upgrade Button Text in Malay",
    },
    {
      fieldName: "Upgrade Button (ZH)",
      fieldValue: "field_upgrade_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_upgrade_text_zh",
      formType: "input",
      label: "Upgrade Button (ZH)",
      placeholder: "Enter Upgrade Button Text in Chinese",
    },
  ],
  eramanProductReview: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Heading Text",
      fieldValue: "field_heading_text",
      className: "col-span-6",
      type: "text",
      name: "field_heading_text",
      formType: "input",
      label: "Heading Text",
      placeholder: "Enter Heading Text",
      validation: { required: "Heading Text is required" },
    },
    {
      fieldName: "Review Title Text",
      fieldValue: "field_review_title",
      className: "col-span-6",
      type: "text",
      name: "field_review_title",
      formType: "input",
      label: "Review Title Text",
      placeholder: "Enter Review Title",
      validation: { required: "Review Title is required" },
    },
    {
      fieldName: "Attachments Text",
      fieldValue: "field_attachments",
      className: "col-span-6",
      type: "text",
      name: "field_attachments",
      formType: "input",
      label: "Attachments Text",
      placeholder: "Enter Attachments",
      validation: { required: "Attachments is required" },
    },
    {
      fieldName: "Browse Files Text",
      fieldValue: "field_browse_files",
      className: "col-span-6",
      type: "text",
      name: "field_browse_files",
      formType: "input",
      label: "Browse Files Text",
      placeholder: "Enter Browse Files Text",
      validation: { required: "Browse Files Text is required" },
    },
    {
      fieldName: "Extensions Text",
      fieldValue: "field_file_extensions_allowed",
      className: "col-span-6",
      type: "text",
      name: "field_file_extensions_allowed",
      formType: "input",
      label: "Extensions Text",
      placeholder: "Enter Extensions Text",
      validation: { required: "Extensions Text is required" },
    },
    {
      fieldName: "Description Text",
      fieldValue: "field_description",
      className: "col-span-6",
      type: "text",
      name: "field_description",
      formType: "input",
      label: "Description Text",
      placeholder: "Enter Description Text",
      validation: { required: "Description Text is required" },
    },
    {
      fieldName: "Submit Text",
      fieldValue: "field_submit_button",
      className: "col-span-6",
      type: "text",
      name: "field_submit_button",
      formType: "input",
      label: "Submit Text",
      placeholder: "Enter Submit Text",
      validation: { required: "Submit Text is required" },
    },
  ],

  epcRenewal: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Renew Epc Card Heading Text",
      fieldValue: "renew_epc_card_heading",
      className: "col-span-6",
      type: "text",
      name: "renew_epc_card_heading",
      formType: "input",
      label: "Renew Epc Card Heading Text",
      placeholder: "Enter Renew Epc Card Heading Text",
      validation: { required: "Renew Epc Card Heading Text is required" },
    },
    {
      fieldName: "Renew Epc Description Text",
      fieldValue: "field_renew_epc_description",
      className: "col-span-6",
      type: "text",
      name: "field_renew_epc_description",
      formType: "richText",
      label: "Renew Epc Description Text",
      placeholder: "Enter Renew Epc Description",
      validation: { required: "Renew Epc Description is required" },
    },
    {
      fieldName: "Apply Renewal Button Text",
      fieldValue: "apply_renewal_button",
      className: "col-span-6",
      type: "text",
      name: "apply_renewal_button",
      formType: "input",
      label: "Apply Renewal Button Text",
      placeholder: "Enter Apply Renewal Button Text",
      validation: { required: "Apply Renewal Button Text is required" },
    },
    {
      fieldName: "Renew text without button",
      fieldValue: "field_renew_text_withoutbutton",
      className: "col-span-6",
      type: "text",
      name: "field_renew_text_withoutbutton",
      formType: "richText",
      label: "Renew text without button",
      placeholder: "Enter Renew text without button",
      validation: { required: "Renew text without button is required" },
    },

  ],

  eramanResetPassword: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Create Password Text",
      fieldValue: "createpassword",
      className: "col-span-6",
      type: "text",
      name: "createpassword",
      formType: "input",
      label: "Create Password Text",
      placeholder: "Enter Create Password Text",
      validation: { required: "Create Password Text is required" },
    },
    {
      fieldName: "Confirm Password Text",
      fieldValue: "confirmpassword",
      className: "col-span-6",
      type: "text",
      name: "confirmpassword",
      formType: "input",
      label: "Confirm Password Text",
      placeholder: "Enter Confirm Password",
      validation: { required: "Confirm Password is required" },
    },
    {
      fieldName: "Validation Rules",
      fieldValue: "resetpassword_description",
      className: "col-span-6",
      type: "text",
      name: "resetpassword_description",
      formType: "richText",
      label: "Validation Rules",
      placeholder: "Enter Validation Rules",
      validation: { required: "Validation Rules is required" },
    },
    // {
    //   fieldName: "Image",
    //   fieldValue: "image",
    //   className: "col-span-6",
    //   type: "image",
    //   usedFileType: "image/*",
    //   formType: "file",
    //   name: "image",
    //   label: "Image",
    //   placeholder: "Upload Image",
    //   validation: { required: "Image is required" },
    // },
    {
      fieldName: "Submit Text",
      fieldValue: "submitbutton",
      className: "col-span-6",
      type: "text",
      name: "submitbutton",
      formType: "input",
      label: "Submit Text",
      placeholder: "Enter Submit",
      validation: { required: "Submit is required" },
    },
  ],
};
